import React from 'react';

export interface ChartNoDataStateProps {
    /** Custom message to display. Defaults to "No data available for the selected filters" */
    message?: string;
    /** Minimum height to match chart area (default 400px) */
    minHeight?: number;
    /** Additional CSS class name */
    className?: string;
    /** Data test ID for testing */
    'data-test-id'?: string;
}

const ChartNoDataState: React.FC<ChartNoDataStateProps> = (props) => {
    const {
        message = 'No data available for the selected filters',
        minHeight = 400,
        className = '',
        'data-test-id': dataTestId,
    } = props;

    return (
        <div
            className={`flex items-center justify-center w-full ${className}`}
            style={{ minHeight }}
            data-test-id={dataTestId}
            data-asper-chart-no-data
        >
            <p className="font-['Open_Sans'] font-normal text-[14px] leading-[22px] text-[rgba(0,0,0,0.45)] m-0">
                {message}
            </p>
        </div>
    );
};

export default ChartNoDataState;
